import { combineReducers } from 'redux';
import customerReport from './customerReport';

export default combineReducers({
  customerReport,
});

export * from './customerReport';
